import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

export default new Router({
    //mode: 'history',
    base: '/j2/',
    routes: [
        {
            path: '/start',
            name: 'start',
            beforeEnter() {location.href = '/'}
        },
        {
            path: '/home',
            name: 'home',
            component: () => import('./views/home'),
        },
        {
            path: '/stoffe',
            component: () => import('./views/stoffe'),
            children: [
                {
                    path: 'home',
                    name: 'stoffe',
                    component: () => import('./views/stoffe/home'),
                    meta: {
                        category: 'stoffe',
                    },
                },
                {
                    path: 'aldehyde',
                    name: 'aldehyde',
                    component: () => import('./views/stoffe/aldehyde'),
                    meta: {
                        category: 'stoffe',
                    },
                },
                {
                    path: 'alkene',
                    name: 'alkene',
                    component: () => import('./views/stoffe/alkene'),
                    meta: {
                        category: 'stoffe',
                    },
                },
                {
                    path: 'alkane',
                    name: 'alkane',
                    component: () => import('./views/stoffe/alkane'),
                    meta: {
                        category: 'stoffe',
                    },
                },
                {
                    path: 'alkine',
                    name: 'alkine',
                    component: () => import('./views/stoffe/alkine'),
                    meta: {
                        category: 'stoffe',
                    },
                },
                {
                    path: 'alkohole',
                    name: 'alkohole',
                    component: () => import('./views/stoffe/alkohole'),
                    meta: {
                        category: 'stoffe',
                    },
                },
                {
                    path: 'amine',
                    name: 'amine',
                    component: () => import('./views/stoffe/amine'),
                    meta: {
                        category: 'stoffe',
                    },
                },
                {
                    path: 'aromaten',
                    name: 'aromaten',
                    component: () => import('./views/stoffe/aromaten'),
                    meta: {
                        category: 'stoffe',
                    },
                },
                {
                    path: 'carbon',
                    name: 'carbon',
                    component: () => import('./views/stoffe/carbon'),
                    meta: {
                        category: 'stoffe',
                    },
                },
                {
                    path: 'ester',
                    name: 'ester',
                    component: () => import('./views/stoffe/ester'),
                    meta: {
                        category: 'stoffe',
                    },
                },
                {
                    path: 'ether',
                    name: 'ether',
                    component: () => import('./views/stoffe/ether'),
                    meta: {
                        category: 'stoffe',
                    },
                },
                {
                    path: 'halogenkohlenwasserstoffe',
                    name: 'halogenkohlenwasserstoffe',
                    component: () =>
                        import('./views/stoffe/halogenkohlenwasserstoffe'),
                    meta: {
                        category: 'stoffe',
                    },
                },
                {
                    path: 'ketone',
                    name: 'ketone',
                    component: () => import('./views/stoffe/ketone'),
                    meta: {
                        category: 'stoffe',
                    },
                },
                {
                    path: 'nitroalkane',
                    name: 'nitroalkane',
                    component: () => import('./views/stoffe/nitroalkane'),
                    meta: {
                        category: 'stoffe',
                    },
                },
                {
                    path: 'aminosauren',
                    name: 'aminosauren',
                    component: () => import('./views/stoffe/aminosauren'),
                    meta: {
                        category: 'stoffe',
                    },
                },
                {
                    path: 'kohlenhydrate',
                    name: 'kohlenhydrate',
                    component: () => import('./views/stoffe/kohlenhydrate'),
                    meta: {
                        category: 'stoffe',
                    },
                },
                {
                    path: 'uebungen',
                    name: 'uebungen',
                    component: () => import('./views/stoffe/uebungen'),
                    meta: {
                        category: 'stoffe',
                    },
                },
                {
                    path: '*',
                    redirect: '/stoffe/home',
                },
            ],
        },
        {
            path: '/reaktionen-nachweise',
            component: () => import('./views/reaktionen'),
            children: [
                {
                    path: 'home',
                    name: 'reaktionen',
                    component: () => import('./views/reaktionen/home'),
                    meta: {
                        category: 'reaktionen',
                    },
                },
                {
                    path: 'elektrophile-addition',
                    name: 'elektrophile-addition',
                    component: () =>
                        import('./views/reaktionen/elektrophile-addition'),
                    meta: {
                        category: 'reaktionen',
                    },
                },
                {
                    path: 'elektrophile-substitution',
                    name: 'elektrophile-substitution',
                    component: () =>
                        import('./views/reaktionen/elektrophile-substitution'),
                    meta: {
                        category: 'reaktionen',
                    },
                },
                {
                    path: 'radikalische-substitution',
                    name: 'radikalische-substitution',
                    component: () =>
                        import('./views/reaktionen/radikalische-substitution'),
                    meta: {
                        category: 'reaktionen',
                    },
                },
                {
                    path: 'estersynthese',
                    name: 'estersynthese',
                    component: () => import('./views/reaktionen/estersynthese'),
                    meta: {
                        category: 'reaktionen',
                    },
                },
                {
                    path: '*',
                    redirect: '/reaktionen-nachweise/home',
                },
            ],
        },
        {
            path: '/gruppen',
            component: () => import('./views/gruppen'),
            children: [
                {
                    path: 'home',
                    name: 'gruppen',
                    component: () => import('./views/gruppen/home'),
                    meta: {
                        category: 'gruppen',
                    },
                },
                {
                    path: 'hydroxyl',
                    name: 'hydroxyl',
                    component: () => import('./views/gruppen/hydroxyl'),
                    meta: {
                        category: 'gruppen',
                    },
                },
                {
                    path: 'carboxyl',
                    name: 'carboxyl',
                    component: () => import('./views/gruppen/carboxyl'),
                    meta: {
                        category: 'gruppen',
                    },
                },
                {
                    path: 'amino',
                    name: 'amino',
                    component: () => import('./views/gruppen/amino'),
                    meta: {
                        category: 'gruppen',
                    },
                },
                {
                    path: 'ester',
                    name: 'ester',
                    component: () => import('./views/gruppen/ester'),
                    meta: {
                        category: 'gruppen',
                    },
                },
                {
                    path: 'aldehyd',
                    name: 'aldehyd',
                    component: () => import('./views/gruppen/aldehyd'),
                    meta: {
                        category: 'gruppen',
                    },
                },
                {
                    path: 'keto',
                    name: 'keto',
                    component: () => import('./views/gruppen/keto'),
                    meta: {
                        category: 'gruppen',
                    },
                },
                {
                    path: 'ether',
                    name: 'ether',
                    component: () => import('./views/gruppen/ether'),
                    meta: {
                        category: 'gruppen',
                    },
                },
                {
                    path: 'nitro',
                    name: 'nitro',
                    component: () => import('./views/gruppen/nitro'),
                    meta: {
                        category: 'gruppen',
                    },
                },
                {
                    path: 'peptid',
                    name: 'peptid',
                    component: () => import('./views/gruppen/peptid'),
                    meta: {
                        category: 'gruppen',
                    },
                },
                {
                    path: '*',
                    redirect: '/reaktionen-nachweise/home',
                },
            ],
        },
        {
            path: '/benennung',
            component: () => import('./views/benennung'),
            children: [
                {
                    path: 'home',
                    name: 'benennung',
                    component: () => import('./views/benennung/home'),
                    meta: {
                        category: 'benennung',
                    },
                },
                {
                    path: 'anleitung',
                    name: 'anleitung',
                    component: () => import('./views/benennung/anleitung'),
                    meta: {
                        category: 'benennung',
                    },
                },
                {
                    path: 'benennung-uebungen',
                    name: 'benennung-uebungen',
                    component: () => import('./views/benennung/uebungen'),
                    meta: {
                        category: 'benennung',
                    },
                },
                {
                    path: '*',
                    redirect: '/benennung/home',
                },
            ],
        },
        {
            path: '/sonstiges',
            component: () => import('./views/sonstiges'),
            children: [
                {
                    path: 'home',
                    name: 'sonstiges',
                    component: () => import('./views/sonstiges/home'),
                    meta: {
                        category: 'sonstiges',
                    },
                },
                {
                    path: 'hueckel',
                    name: 'hueckel',
                    component: () => import('./views/sonstiges/hueckel'),
                    meta: {
                        category: 'sonstiges',
                    },
                },
                {
                    path: 'verschiebung-gg',
                    name: 'verschiebung-gg',
                    component: () =>
                        import('./views/sonstiges/verschiebung-gg'),
                    meta: {
                        category: 'sonstiges',
                    },
                },
                {
                    path: 'pks',
                    name: 'pks',
                    component: () => import('./views/sonstiges/pks'),
                    meta: {
                        category: 'sonstiges',
                    },
                },
                {
                    path: 'induktiver-effekt',
                    name: 'induktiver-effekt',
                    component: () =>
                        import('./views/sonstiges/induktiver-effekt'),
                    meta: {
                        category: 'sonstiges',
                    },
                },
                {
                    path: 'mesomerie',
                    name: 'mesomerie',
                    component: () => import('./views/sonstiges/mesomerie'),
                    meta: {
                        category: 'sonstiges',
                    },
                },
                {
                    path: 'allgemeine-uebungen',
                    name: 'allgemeine-uebungen',
                    component: () => import('./views/sonstiges/uebungen'),
                    meta: {
                        category: 'sonstiges',
                    },
                },
                {
                    path: '*',
                    redirect: '/sonstiges/home',
                },
            ],
        },
        {
            path: '/karteikarten',
            name: 'karteikarten',
            component: () => import('./views/karteikarten'),
            children: [
                {
                    path: 'home',
                    name: 'karteikarten',
                    component: () => import('./views/karteikarten/home'),
                    meta: {
                        category: 'karteikarten',
                    },
                },
                {
                    path: 'stoffklassen',
                    name: 'stoffklassen',
                    component: () =>
                        import('./views/karteikarten/stoffklassen'),
                    meta: {
                        category: 'karteikarten',
                    },
                },
                {
                    path: 'reaktionen-nachweise',
                    name: 'reaktionen-nachweise',
                    component: () =>
                        import('./views/karteikarten/reaktionen-nachweise'),
                    meta: {
                        category: 'karteikarten',
                    },
                },
                {
                    path: 'sonstiges',
                    name: 'sonstiges',
                    component: () => import('./views/karteikarten/sonstiges'),
                    meta: {
                        category: 'karteikarten',
                    },
                },
                {
                    path: '*',
                    redirect: '/karteikarten/home',
                },
            ],
        },
        {
            path: '*',
            redirect: '/home',
        },
    ],
    linkActiveClass: 'active',
    scrollBehavior(to, from, savedPosition) {
        if (to.hash) {
            return {
                selector: to.hash,
            };
        } else if (savedPosition) {
            return savedPosition;
        } else {
            return { x: 0, y: 0 };
        }
    },
});
